import {
  FETCH_ADMIN_SHARED_TENANTS_REQUEST,
  FETCH_ADMIN_SHARED_TENANTS_SUCCESS,
  FETCH_ADMIN_SHARED_TENANTS_FAILURE,
} from '../../../../Constants/actionTypes';
import { getAdminSharedTenants } from '../../../../Constants/apiService';
import { normalizeAdminTenantListItem } from '../../../../../Pages/Dashboard/Admin/Tenants/adminTenantMappers';
import { enrichTenantWithItsmUrl } from '../../../../../Pages/Dashboard/Admin/Tenants/tenantHelpers';

export const fetchAdminSharedTenantsRequest = () => ({
  type: FETCH_ADMIN_SHARED_TENANTS_REQUEST,
});

export const fetchAdminSharedTenantsSuccess = (tenants) => ({
  type: FETCH_ADMIN_SHARED_TENANTS_SUCCESS,
  payload: tenants,
});

export const fetchAdminSharedTenantsFailure = (error) => ({
  type: FETCH_ADMIN_SHARED_TENANTS_FAILURE,
  payload: error,
});

export const fetchAdminSharedTenantsAct = () => async (dispatch, getState) => {
  dispatch(fetchAdminSharedTenantsRequest());

  const accessToken = getState()?.auth?.accessToken;

  try {
    const data = await getAdminSharedTenants(accessToken);
    const tenants = (data?.sharedTenants || [])
      .map(normalizeAdminTenantListItem)
      .map(enrichTenantWithItsmUrl);
    dispatch(fetchAdminSharedTenantsSuccess(tenants));
    return tenants;
  } catch (error) {
    const errorMessage =
      error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
        ? 'Unable to load shared tenants.'
        : error?.message || 'Unable to load shared tenants.';

    dispatch(fetchAdminSharedTenantsFailure(errorMessage));
    return null;
  }
};
